import { createEntityCollectionStore, getEntityCollectionActions } from '@core/ngrx-legacy';
import type { SearchableField } from '@core/profile-fields-types';

const { actions, selectors, reducer, namespace } = createEntityCollectionStore<SearchableField>()(
  'searchable-field',
  {
    customActions: adapter => {
      const selectName = ({ name }: SearchableField) => name;
      const defaultActions = getEntityCollectionActions(adapter, selectName);

      return {
        fetchCollectionSuccess: (state, payload: { data: SearchableField[] }) =>
          defaultActions.fetchCollectionSuccess(state, payload),
      };
    },
  },
);

export {
  actions as ProfileFieldsSearchableFieldCollectionActions,
  selectors as ProfileFieldsSearchableFieldCollectionSelectors,
  reducer as ProfileFieldsSearchableFieldCollectionReducer,
  namespace as ProfileFieldsSearchableFieldCollectionNamespace,
};
